import React from "react";
import { Link } from "react-router-dom";
import MoreHoriz from "@mui/icons-material/MoreHoriz";

// Phone navigation: the first four menus the user can see (in sidebar order) plus "More", which opens the full drawer.
export default function BottomNav({ navTree, hasAccess, hiddenModules, pathname, badges, onGroup, onMore }) {
  const entries = [];
  navTree.forEach((node) => {
    if (node.type === "item") {
      if (hasAccess(node.item.module) && !hiddenModules.includes(node.item.module)) {
        entries.push({ key: node.item.path, label: node.item.label, icon: node.item.icon, path: node.item.path,
          active: pathname.startsWith(node.item.path), count: badges[node.item.module] || 0 });
      }
    } else {
      const visible = node.items.filter((it) => hasAccess(it.module) && !hiddenModules.includes(it.module));
      if (visible.length) {
        entries.push({ key: `g${node.id}`, label: node.label, icon: node.icon, group: node.id,
          active: visible.some((it) => pathname.startsWith(it.path)), count: visible.reduce((s, it) => s + (badges[it.module] || 0), 0) });
      }
    }
  });
  const tabs = entries.slice(0, 4);
  if (!tabs.length) return null;

  const body = (t) => (
    <>
      <t.icon style={{ fontSize: 22 }} />
      <span>{t.label}</span>
      {t.count > 0 && <span className="bn-badge">{t.count > 99 ? "99+" : t.count}</span>}
    </>
  );
  return (
    <nav className="bottom-nav" aria-label="Quick navigation">
      {tabs.map((t) =>
        t.path ? (
          <Link key={t.key} to={t.path} className={`bn-tab ${t.active ? "active" : ""}`} aria-current={t.active ? "page" : undefined}>{body(t)}</Link>
        ) : (
          <button key={t.key} type="button" className={`bn-tab ${t.active ? "active" : ""}`} onClick={() => onGroup(t.group)}>{body(t)}</button>
        ),
      )}
      <button type="button" className="bn-tab" onClick={onMore}>
        <MoreHoriz style={{ fontSize: 22 }} />
        <span>More</span>
      </button>
    </nav>
  );
}
